module.exports = __webpack_public_path__ + "img/ico-circle-plus.bcf7b80f.svg";